import * as React from 'react'
import { FaCloudUploadAlt as CloudUploadIcon } from '@react-icons/all-files/fa/FaCloudUploadAlt'
import styles from './index.module.css'

type Props = {
  targetText?: string
}
export default class FileDropOverlay extends React.Component<Props> {
  _getTargetText(): string {
    if (this.props.targetText) {
      return `to ${this.props.targetText}`
    } else {
      return ''
    }
  }

  render(): React.ReactElement<'div'> {
    return (
      <div className={styles.fileDropOverlayCont}>
        <div className={styles.fileDropOverlayIcon}>
          <CloudUploadIcon />
        </div>
        Drag files to upload them instantly {this._getTargetText()}
      </div>
    )
  }
}
